import { v4 as uuidv4 } from 'uuid'
import { Range } from 'vendor/slate'
import { addCommentMark } from './transforms'

export const withComments = (editor, { currentUserId = null } = {}) => {
  editor.commentUserId = currentUserId

  // Assigned by the React layer (editor.js) so this plugin stays UI-agnostic.
  // Defaults to a no-op until wired so leaf click handlers are always safe.
  if (typeof editor.openCommentThread !== 'function') {
    editor.openCommentThread = () => {}
  }

  // Create a new comment thread over `range`, returning its generated threadId
  // (also used as the comment record's reference). Returns null for an empty
  // or collapsed selection.
  editor.addComment = (range = editor.selection, userId = editor.commentUserId) => {
    if (!range || Range.isCollapsed(range)) return null

    const threadId = uuidv4()
    addCommentMark(editor, range, threadId, userId)
    return threadId
  }

  return editor
}

export {
  addCommentMark,
  removeCommentMark,
  findCommentThreadIds,
  getCommentThreadIdsFromLeaf,
  leafHasComment
} from './transforms'

export { COMMENT_ROOT, getCommentKey } from './constants'
